import { render, staticRenderFns } from "./ConfirmVitalsModal.vue?vue&type=template&id=6464e4a8&functional=true&"
import script from "./ConfirmVitalsModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmVitalsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports